import React from 'react';
import FontAwesome from 'react-fontawesome';

import './OffscreenSlider.sass';

interface ISliderProps {
    height: number; // required to hide horizontal scrollbar
    slideDelta: number; // distance to slide when arrow is clicked
    children?: React.ReactNode;
}

class OffscreenSlider extends React.Component<ISliderProps> {
    public static easeInOutQuad(time: number, start_val: number, change: number, duration: number) {
        let calcTime = time / (duration / 2);
        if (calcTime < 1) return change / 2 * calcTime * calcTime + start_val;
        calcTime -= 1;
        return -change / 2 * (calcTime * (calcTime - 2) - 1) + start_val;
    }

    public SlideAreaElement: HTMLDivElement;

    constructor(props: ISliderProps) {
        super(props);
        this.onArrowClick = this.onArrowClick.bind(this);
    }

    public scrollBy(element: HTMLDivElement, velocity: number, duration: number) {
        const start = 0;
        const increment = 20;
        let currentTime = 0;
        let lastDistance = 0;

        const animateScroll = () => {
            currentTime += increment;
            const currentDistanceTraveled = OffscreenSlider.easeInOutQuad(currentTime, start, velocity, duration);
            const delta = currentDistanceTraveled - lastDistance;
            lastDistance = currentDistanceTraveled;
            element.scrollBy(delta, 20);
            if (currentTime < duration) setTimeout(animateScroll, increment);
        };
        animateScroll();
    }

    public onArrowClick(ev: React.MouseEvent<any>): void {
        const slideVelocity = this.props.slideDelta * (ev.currentTarget.className.includes('Right-arrow') ? 1 : -1);

        this.scrollBy(this.SlideAreaElement, slideVelocity, 600);
    }

    public render() {
        return(
            <div className="Offscreenslider-container" style={{ height: this.props.height }}>
                <FontAwesome onClick={this.onArrowClick} className="Left-arrow" name="chevron-left" />
                <FontAwesome onClick={this.onArrowClick} className="Right-arrow" name="chevron-right" />
                {/* Set height and pad bottom to hide scrollbar --v */}
                <div ref={el => this.SlideAreaElement = el} className="Offscreenslider-slide-area" style={{ height: this.props.height, paddingBottom: 5 }}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default OffscreenSlider;



// WEBPACK FOOTER //
// ./src/components/global/application/OffscreenSlider.tsx